import { BarChart3 } from "lucide-react"

interface LoadBalancerEmptyStateProps {
  onCreateClick: () => void
}

export default function LoadBalancerEmptyState({ onCreateClick }: LoadBalancerEmptyStateProps) {
  return (
    <div className="p-8 text-center">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <BarChart3 className="w-8 h-8 text-gray-400" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">No configurations found</h3>
      <p className="text-gray-600 mb-4">Create your first load balancer configuration to get started.</p>
      <button
        onClick={onCreateClick}
        className="bg-blue-600 text-white px-6 py-3 rounded-xl hover:bg-blue-700 transition-colors"
      >
        Create Configuration
      </button>
    </div>
  )
}
